<template>
  <div class="postcode-container">
    <div id="kakao-postcode-search"></div>
    <button
      style="
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10001;
        background: #fff;
        border: 1px solid #ddd;
        border-radius: 3px;
        padding: 5px 10px;
        cursor: pointer;
        font-size: 12px;
      "
      @click="close"
    >
      닫기
    </button>
  </div>
</template>

<script>
export default {
  name: "KakaoPostcode",
  props: {
    onComplete: {
      type: Function,
      required: true
    }
  },
  mounted() {
    this.loadScript();
  },
  methods: {
    loadScript() {
      if (window.daum && window.daum.Postcode) {
        this.initPostcode();
        return;
      }

      const script = document.createElement("script");
      script.src =
        "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
      script.onload = () => {
        this.$nextTick(() => {
          this.initPostcode();
        });
      };
      document.head.appendChild(script);
    },
    initPostcode() {
      new window.daum.Postcode({
        oncomplete: data => {
          if (this.onComplete) {
            this.onComplete(data);
          }
        },
        width: "100%",
        height: "100%"
      }).embed(this.$el.querySelector("#kakao-postcode-search"));
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.postcode-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
#kakao-postcode-search {
  flex: 1;
  width: 100%;
  min-height: 400px;
}
</style>
